import { z, ZodRawShape } from 'zod';

export const parseZodSchema = <T extends ZodRawShape>(
  values: T,
  zodSchema: z.ZodEffects<z.ZodObject<T>> | z.ZodObject<T>,
  printError: boolean = false,
) => {
  try {
    zodSchema.parse(values);
    return true;
  } catch (e) {
    if (printError) {
      console.log('>>> PARSE ZOD SCHEMA error >>>');
      console.log('Values:', values);
      console.log('Schema:', zodSchema);
      console.log('Error:', e);
    }
    return false;
  }
};
